import { actionGenerator, IReduxAction } from '../../utils/actions';

export const SET_PROMOTION_TYPE_CHANGE_REASON = 'PUBLISH_TERMS :: PROMOTION_TYPE_CHANGE_REASON :: SET';

type TPayload = null | string;

export type TSetPromotionTypeChangeReasonAction = IReduxAction<typeof SET_PROMOTION_TYPE_CHANGE_REASON, TPayload>;

export const setPromotionTypeChangeReason = actionGenerator<typeof SET_PROMOTION_TYPE_CHANGE_REASON, TPayload>(
  SET_PROMOTION_TYPE_CHANGE_REASON,
);
